<template>
  <div
    id="content_holder"
    class="
      flex-grow
      grid grid-cols-1
      px-4
      gap-4
      md:grid-cols-2
      lg:grid-cols-3
      mt-14
      mb-4
      md:mt-4
      lg:pl-8
      items-start
      justify-start
      container
      mx-auto
    "
  >
    <Notification />
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <Carpo />
  </div>
</template>
<script>
import Carpo from "@/components/elements/Carpo.vue";
import Notification from "@/components/Notification/NotifiactionHolder.vue";

export default {
  components: {
    Carpo,
    Notification,
  },
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
